"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 *
 * @param firestore
 * @returns Cantidad de pacientes esperando ser atendidos con el estado ```ASSIGN```
 * Se buscan en ```assignations/online_clinica_medica/bag```
 */
async function getAmmountOfPendingAppointments(firestore) {
    const path = "/assignations/online_clinica_medica/bag";
    let appointments;
    try {
        const appointmentRef = (0, firestore_1.collection)(firestore, path);
        const appointmentQuery = (0, firestore_1.query)(appointmentRef, (0, firestore_1.where)("state", "==", "ASSIGN"));
        appointments = await (0, firestore_1.getDocs)(appointmentQuery);
    }
    catch (err) {
        throw new Error(`db error ${err}`);
    }
    if (appointments.empty) {
        return 0;
    }
    else {
        return appointments.size;
    }
}
exports.default = getAmmountOfPendingAppointments;
